import request from '@/utils/request'

// 获取员工列表
export function fetchGetStaffsList (data) {
  return request({
    url: '/personal/employee/allEmployee',
    method: 'post',
    data
  })
}

// 删除员工
export function fetchGetStaffInfo (employeeNo) {
  const data = {
    keyword: employeeNo
  }

  return request({
    url: '/personal/employee/getEmployeeId',
    method: 'post',
    data
  })
}

// 添加员工信息
export function fetchAddStaff (data) {
  return request({
    url: '/personal/employee/addEmployee',
    method: 'post',
    data
  })
}

// 编辑员工信息更新
export function fetchEditStaff (data) {
  return request({
    url: '/personal/employee/updateEmployee',
    method: 'post',
    data
  })
}

// 删除员工
export function fetchRemoveStaff (employeeNo) {
  const data = {
    keyword: employeeNo
  }

  return request({
    url: '/personal/employee/deleteEmployee',
    method: 'post',
    data
  })
}

export function fetchResetStaffPassword (employeeNo) {
  const data = {
    keyword: employeeNo
  }

  return request({
    url: '/personal/employee/againPwd',
    method: 'post',
    data
  })
}

// 判断员工工号是否合法
export function fetchJudgeNewEmployeeNo (employeeNo) {
  const data = {
    keyword: employeeNo
  }
  return request({
    url: '/personal/employee/isExistenceEmployeeId',
    method: 'post',
    data
  })
}

// 获取工号
export function fetchGetNewEmployeeNo () {
  return request({
    url: '/personal/employee/getNewEmployeeNo',
    method: 'post'
  })
}

// 获取外协人员工号
export function getWXNewEmployeeNo () {
  return request({
    url: '/personal/employee/getWXNewEmployeeNo',
    method: 'post'
  })
}

// 获取角色
export function fetchGetRole () {
  return request({
    url: '/staff/dropDownBox/role',
    method: 'post'
  })
}

// 修改密码
export function fetchResetPassword (data) {
  return request({
    url: '/personal/employee/resetPwd',
    method: 'post',
    data
  })
}

// 签到签退
export function fetchAttendance (datas) {
  const data = {
    addr: datas.addr,
    latitude: datas.latitude,
    longitude: datas.longitude,
    operate: datas.operate,
    type: datas.type
  }
  return request({
    url: '/personal/attendance/punchClock',
    method: 'post',
    data
  })
}
// 批量获取用户
export function selectBatchEmployee (data) {
  return request({
    url: '/personal/employee/selectBatch',
    method: 'post',
    data
  })
}

// 离职
export function staffDimission (employeeNo) {
  return request({
    url: `/personal/employee/departureProcess?employeeNo=${employeeNo}`,
    method: 'post'
  })
}

//根据项目id获取项目成员
export function getPorjectById (data) {
  return request({
    url: `/personal/project/selectProjectId`,
    method: 'post',
    data
  })
}

//修改用户指定字段
export function upDateBatch (data) {
  return request({
    url: `/personal/employee/upDateBatch`,
    method: 'post',
    data
  })
}

// 获取员工所在公司和部门
export function employeeOrganization (data) {
  return request({
    url: `/personal/employee/employeeOrganization`,
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/staff.js